import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { ModalOk } from "../ui/modal/ModalOk"
import { msg } from "../ui/modal/utils"
import { useState } from "react"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"

import { useQuery } from "../../hooks/useQuery"
import { Trans, useTranslation } from "react-i18next"

export const ModalEditarConsigna = ({ show, entry, setEntries }) => {
  // <- nombre

  const [con, setCon] = useState(entry) // <- nombre de esta variable

  const updateCon = useQuery(), // <- nombre
    showRes = useState(false)

  const runQuery = async () => {
    showRes[1](true)

    // recolecto toda la data necesaria para el fetch
    const tkn = getCookie("jwt"),
      { url, opt } = api.consignas.update({ token: tkn, con_id: con.id, con }) // <- estos datos

    // ejecuto
    updateCon.url.current = url
    updateCon.opt.current = opt

    updateCon.run({
      onOk: () => {
        setEntries((current) => ({
          total: current.total,
          entries: current.entries.map((c) => {
            if (c.id !== entry.id) return c
            return con
          }),
        }))
      },
    })
  }

  const { t } = useTranslation()

  const bodyModalEditarConsigna = () => {
    // <- nombre

    return (
      <>
        <div className="p-3 pt-0" style={{ background: "hsl(0deg 0% 90%)" }}>
          <div className="form-group">
            <label className="form-label mt-4">
              {t(`modals.modal_editar_consigna.title`)}
            </label>
            <input
              onChange={(e) => {
                setCon((current) => ({ ...current, titulo: e.target.value }))
              }}
              value={con.titulo}
              className="form-control"
              placeholder={t(`modals.modal_editar_consigna.title_placeholder`)}
            />
          </div>
        </div>
      </>
    )
  }

  const footerModalEditarConsigna = () => {
    // <- nombre
    const handleCancelar = () => show[1](false)
    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleCancelar()}
        >
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-primary"
          disabled={updateCon.isPending}
          onClick={() => runQuery()}
        >
          {updateCon.isPending
            ? t(`ui.btns.submiting`) + "..."
            : t(`ui.btns.save`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="editar-consigna" // <--
        show={show}
        header={<center>{t(`modals.modal_editar_consigna.header`)}</center>}
        body={bodyModalEditarConsigna()}
        footer={footerModalEditarConsigna()}
      />

      {/* modales para los resultados */}

      {
        updateCon.res && !updateCon.err && (
          <ModalOk
            show={[showRes[0], show[1]]}
            body={msg(
              <Trans
                i18nKey="modals.modal_editar_consigna.sucess_msg"
                values={{ consigna: con.name }}
                components={{ i: <i /> }}
              />
            )}
          />
        ) // <- string
      }

      {updateCon.res && updateCon.err && (
        <ModalError show={showRes} res={updateCon.res} />
      )}
    </>
  )
}
